module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABRUExURUdwTC1g/zFm/zJl/6rG/5Oq/67I/y5b/zJm/67J/6/K/67J/67J/67J/zJl/3Gb/y9k/67I/67J/67J/zJl/zFk/67J/6rJ/zNm/67J/zNm/yXP/jgAAAAZdFJOUwAoh+5IBNcc398vt55YtBI2z4brzHx2IWSsqVyvAAAArklEQVQoz+XSWxKDIAwF0FjFFwK+22T/C20ERCviBnp/mMn5YCa5AJDN9BNtAEDJVcAWUdMlmqclYme9oig87dD7xksWoh2D9M6cwxHj2bqKGDwb/h2HFIuBFZsUK3xkkNOUYreQIsWIo0hwbxkbcTDVrxByjOuJr0sdEcsHbv+cy3s2vNWC2ygTTbVd2bsWczuha6roY+Zjv0cpFb86Vsr7cP78hmkJ/KnjzNWuX4y6N2+9L/XnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MallPage/petrified.png
// module id = ADu3
// module chunks = 0